import React, { useState, memo } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSitemap, faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import SubcuentaDistribucionList from "../SubcuentaDistribucionList/SubcuentaDistribucionList";

const RRDistribuciones = ({ item, style }) => {

    const [distribucionSelected, setDistribucionSelected] = useState('');
    const [openDropdown, setOpenDropdown] = useState(false);

    const key = `${item.codDim?.trim()}-${item.codDis?.trim()}`;

    const handleClick = () => {
        setDistribucionSelected(prev => prev === key ? "" : key);
        setOpenDropdown(prev => !prev);
    };

    return (
        <div style={style} className='warehouseRow' id={key}>
            <div className='warehouseDataRow'>
                <div className='list-item-icon-w'><FontAwesomeIcon icon={faSitemap} /></div>
                <div className="label-title-warehouses">Dimensión: <h6>{item.codDim?.trim()} - {item.codDimDescrp?.trim()}</h6></div>
                <div className="label-title-warehouses">Distribución: <h6>{item.codDis?.trim()} - {item.codDisDescrp?.trim()}</h6></div>
                <div><h5 style={{ marginTop: "13px" }}>Subcuentas: </h5><h6>
                    <div className="div-icon-warehouse-sectors" onClick={handleClick}>
                        <FontAwesomeIcon className="icon-warehouse-sectors" icon={openDropdown ? faCaretUp : faCaretDown} />
                    </div></h6></div>
            </div>
            <div style={{ width: "100%" }}>
                <SubcuentaDistribucionList
                    subcuentas={item.subcuentas}
                    distribucionKey={key}
                    distribucionSelected={distribucionSelected}
                />
            </div>
        </div>
    );
};

export default memo(RRDistribuciones);
